import createIcon from '../../createIcon';

/**
 * @component @name Dvr
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM0gzQzEuOSAzIDEgMy45IDEgNVYxN0MxIDE4LjEgMS45IDE5IDMgMTlIOFYyMUgxNlYxOUgyMUMyMi4xIDE5IDIyLjk5IDE4LjEgMjIuOTkgMTdMMjMgNUMyMyAzLjkgMjIuMSAzIDIxIDNaTTIxIDE3SDNWNUgyMVYxN1pNMTkgOEg4VjEwSDE5VjhaTTE5IDEySDhWMTRIMTlWMTJaTTcgOEg1VjEwSDdWOFpNNyAxMkg1VjE0SDdWMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Dvr = createIcon('Dvr', [
  [
    'path',
    {
      d: 'M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17ZM19 8H8V10H19V8ZM19 12H8V14H19V12ZM7 8H5V10H7V8ZM7 12H5V14H7V12Z',
      key: 'fzv9h2',
    },
  ],
]);

export default Dvr;
